import _objectSpread from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import { getToken } from '@/utils/auth';
var UoocWebSocket = /*#__PURE__*/function () {
  function UoocWebSocket() {
    _classCallCheck(this, UoocWebSocket);
    _defineProperty(this, "token", getToken());
    this.websock = null;
    this.reconnectData = null;
    this.lockReconnect = false; // 避免重复连接，因为onerror之后会立即触发 onclose
    this.timeout = 10000; // 10s一次心跳检测
    this.timeoutObj = 0;
    this.serverTimeoutObj = 0;
    this.onlineStatusTimer = 0;
    this.data = {
      'GOOD_NEWS': {},
      'ONLINE_STATUS': ''
    };
  }
  // 初始化weosocket
  return _createClass(UoocWebSocket, [{
    key: "initWebSocket",
    value: function initWebSocket() {
      // 这块的思路就是，新建websocket，然后通过heartBeat函数向后端发送心跳，后端返回type为heartbeat的消息，清空计时器
      // 或者收到喜报就清空计时器，如果无消息超过一定时间则重连。销毁的时候，直接关闭连接。
      // 在线状态也由websocket判断
      var wsurl = process.env.VUE_APP_SOCKET_URL + "?Authorization=".concat(this.token);
      var websocketOnOpen = this.websocketOnOpen,
        websocketOnMessage = this.websocketOnMessage,
        websocketOnError = this.websocketOnError,
        websocketClose = this.websocketClose;
      this.websock = new WebSocket(wsurl); // new个websocket

      var _this = this;
      this.websock.onopen = function (wb, e) {
        websocketOnOpen.call(_this, wb, e);
      };
      // 连接成功
      this.websock.onmessage = function (data) {
        websocketOnMessage.call(_this, data);
      };
      // 广播成功
      // 连接断开，失败
      this.websock.onerror = function (wb, e) {
        websocketOnError.call(_this);
      };
      // 连接关闭
      this.websock.onclose = function () {
        websocketClose.call(_this);
      };
    }
    // 连接成功
  }, {
    key: "websocketOnOpen",
    value: function websocketOnOpen(wb, e) {
      this.heatBeat();
      this.sendOnlineStatus();
    }
    // 连接失败
  }, {
    key: "websocketOnError",
    value: function websocketOnError(e) {
      this.reconnect();
    }
    // 各种问题导致的 连接关闭
  }, {
    key: "websocketClose",
    value: function websocketClose(wb, e) {
      this.reconnect();
    }
  }, {
    key: "websocketOnMessage",
    value: function websocketOnMessage(data) {
      // 收到消息会刷新心跳检测，如果一直收到消息，就推迟心跳发送
      this.heatBeat();
      // responseType = 'GOOD_NEWS'
      var _JSON$parse = JSON.parse(data.data),
        type = _JSON$parse.type,
        content = _JSON$parse.content;
      if (data && type) {
        if (type === 'GOOD_NEWS') {
          var goodnews = _objectSpread({
            // 是为了区分同时弹出的喜报
            id: Math.random()
          }, content);
          this.data[type] = goodnews;
        } else {
          this.data[type] = content;
        }
      }
    }
    // 数据发送
  }, {
    key: "websocketSend",
    value: function websocketSend(data) {
      this.websock.send(JSON.stringify(data));
    }
    // socket重连
  }, {
    key: "reconnect",
    value: function reconnect() {
      var _this2 = this;
      if (this.lockReconnect) {
        return;
      }
      this.lockReconnect = true;
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(function () {
        _this2.initWebSocket();
        _this2.lockReconnect = false;
      }, 5000);
    }
    // 心跳检测
  }, {
    key: "heatBeat",
    value: function heatBeat() {
      var _this3 = this;
      this.timeoutObj && clearTimeout(this.timeoutObj);
      this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
      this.timeoutObj = setTimeout(function () {
        _this3.websocketSend({
          type: 'HEARTBEAT'
        });
        _this3.serverTimeoutObj = setTimeout(function () {
          _this3.websock.close(); // 如果  5秒之后我们没有收到 后台返回的心跳检测数据 断开socket，断开后会启动重连机制
        }, 5000);
      }, this.timeout);
    }

    // 断开连接及清除各种计时器
  }, {
    key: "closeWebSocket",
    value: function closeWebSocket() {
      this.lockReconnect = true;
      var reconnectData = this.reconnectData,
        timeoutObj = this.timeoutObj,
        serverTimeoutObj = this.serverTimeoutObj,
        onlineStatusTimer = this.onlineStatusTimer;
      // websock.close(); // 离开路由之后断开websocket连接
      clearTimeout(reconnectData); // 离开清除 timeout
      clearTimeout(timeoutObj); // 离开清除 timeout
      clearTimeout(serverTimeoutObj); // 离开清除 timeout
      clearInterval(onlineStatusTimer);
    }

    // 主动退出登录
  }, {
    key: "logout",
    value: function logout() {
      this.websocketSend({
        type: 'LOGOUT'
      });
      this.closeWebSocket();
    }

    // 关闭浏览器
  }, {
    key: "closeWeb",
    value: function closeWeb() {
      this.websocketSend({
        type: 'BROWSER_CLOSE'
      });
      this.closeWebSocket();
    }

    // 探活 一分钟发一次
  }, {
    key: "sendOnlineStatus",
    value: function sendOnlineStatus() {
      var _this4 = this;
      var token = this.token;
      // 马上先查询一下在线状态
      this.websocketSend({
        type: 'ONLINE_STATUS',
        token: token
      });
      this.onlineStatusTimer = setInterval(function () {
        _this4.websocketSend({
          type: 'ONLINE_STATUS',
          token: token
        });
      }, 60 * 1000);
    }
  }]);
}();
export { UoocWebSocket as default };